import { useRef } from 'react';

export const usePrevious = <T>(value: T, initial?: T): T | undefined => {
  const ref = useRef({ target: value, previous: initial });

  if (JSON.stringify(ref.current.target) !== JSON.stringify(value)) {
    // The value changed.
    ref.current.previous = ref.current.target;
    ref.current.target = value;
  }

  return ref.current.previous as T;
};
